import { inherits as _inherits, createClass as _createClass, superPropGet as _superPropGet, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { enums } from '@optimizely/react-sdk';
import { BaseLogHandler } from './baseLogHandler.js';
import { getLogMessage } from '../../utils.js';

var ConsoleLogHandler = /*#__PURE__*/function (_BaseLogHandler) {
  function ConsoleLogHandler() {
    _classCallCheck(this, ConsoleLogHandler);
    return _callSuper(this, ConsoleLogHandler, arguments);
  }
  _inherits(ConsoleLogHandler, _BaseLogHandler);
  return _createClass(ConsoleLogHandler, [{
    key: "handle",
    value: function handle(logLevel, message) {
      var LOG_LEVEL = enums.LOG_LEVEL;
      var logMessage = getLogMessage(logLevel, message);
      switch (logLevel) {
        case LOG_LEVEL.INFO:
          console.info(logMessage);
          break;
        case LOG_LEVEL.DEBUG:
          console.debug(logMessage);
          break;
        case LOG_LEVEL.WARNING:
          console.warn(logMessage);
          break;
        case LOG_LEVEL.ERROR:
          console.error(logMessage);
          break;
      }
      _superPropGet(ConsoleLogHandler, "handle", this, 3)([logLevel, message]);
    }
  }]);
}(BaseLogHandler);
var consoleLogHandler = new ConsoleLogHandler();

export { consoleLogHandler as default };
